import { Stack } from '@mui/material';
import { Match, Switch } from '@side/pantry';
import { OFFER_STEPS } from '../constants/steps';
import { useCreateOfferContext } from '../context/CreateOfferContext';
import { AddressStep } from './AddressStep';
import { BuyerStep } from './BuyerStep';
import { ErrorPage } from './ErrorPage';

export const StepRenderer = () => {
  const { errorMessage, step } = useCreateOfferContext();

  return (
    <Stack
      sx={{
        gap: 2,
        width: { xs: 'unset', lg: '80%' },
        minWidth: 0,
      }}
    >
      <Switch>
        <Match when={errorMessage}>
          <ErrorPage errorMessage={errorMessage!} />
        </Match>
        <Match when={step === OFFER_STEPS.buyer}>
          <BuyerStep />
        </Match>
        <Match when>
          <AddressStep />
        </Match>
      </Switch>
    </Stack>
  );
};
